import { c as _c } from "react/compiler-runtime";
import { cn } from '@/app/_lib/utils';
type BashProps = React.SVGProps<SVGSVGElement> & {
  size?: string | number;
};
export function Bash(t0) {
  const $ = _c(13);
  let className;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      size,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = size;
  } else {
    className = $[1];
    props = $[2];
    size = $[3];
  }
  const sizeClass = size ? `size-${size}` : "size-12";
  let t1;
  if ($[4] !== className || $[5] !== sizeClass) {
    t1 = cn(sizeClass, className);
    $[4] = className;
    $[5] = sizeClass;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  let t3;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path fill="none" d="M4.24 4.24h119.53v119.53H4.24z" />;
    t3 = <path fill="#293138" d="M109.01 28.64L71.28 6.24c-2.25-1.33-4.77-2-7.28-2s-5.03.67-7.28 2.01l-37.74 22.4c-4.5 2.67-7.28 7.61-7.28 12.96v44.8c0 5.35 2.77 10.29 7.28 12.96l37.73 22.4c2.25 1.34 4.76 2 7.28 2 2.51 0 5.03-.67 7.28-2l37.74-22.4c4.5-2.67 7.28-7.62 7.28-12.96V41.6c0-5.34-2.77-10.29-7.28-12.96zM79.79 98.59l.06 3.22c0 .39-.25.83-.55.99l-1.91 1.1c-.3.15-.56-.03-.56-.42l-.03-3.17c-1.63.68-3.29.84-4.34.42-.2-.08-.29-.37-.21-.71l.69-2.91c.06-.23.18-.46.34-.6.06-.06.12-.1.18-.13.11-.06.22-.07.31-.03 1.14.38 2.59.2 3.99-.5 1.78-.9 2.97-2.72 2.95-4.52-.02-1.64-.9-2.31-3.05-2.33-2.74.01-5.3-.53-5.34-4.57-.03-3.32 1.69-6.78 4.43-8.96l-.03-3.25c0-.4.24-.84.55-1l1.85-1.18c.3-.15.56.04.56.43l.03 3.25c1.36-.54 2.54-.69 3.61-.44.23.06.34.38.24.75l-.72 2.88c-.06.22-.18.44-.33.58a.77.77 0 01-.19.14c-.1.05-.19.06-.28.05-.49-.11-1.65-.36-3.48.56-1.92.97-2.59 2.64-2.58 3.88.02 1.48.77 1.93 3.39 1.97 3.49.06 4.99 1.58 5.03 5.09.05 3.44-1.79 7.15-4.61 9.41zm26.34-60.5l-35.7 22.05c-4.45 2.6-7.73 5.52-7.74 10.89v43.99c0 3.21 1.3 5.29 3.29 5.9-.65.11-1.32.19-1.98.19-2.09 0-4.15-.57-5.96-1.64l-37.73-22.4c-3.69-2.19-5.98-6.28-5.98-10.67V41.6c0-4.39 2.29-8.48 5.98-10.67l37.74-22.4c1.81-1.07 3.87-1.64 5.96-1.64s4.15.57 5.96 1.64l37.74 22.4c3.11 1.85 5.21 5.04 5.8 8.63-1.27-2.67-4.09-3.39-7.38-1.47z" />;
    t4 = <path fill="#4FA847" d="M99.12 90.73l-9.4 5.62c-.25.15-.43.31-.43.61v2.46c0 .3.2.43.45.28l9.54-5.8c.25-.15.29-.42.29-.72v-2.17c0-.3-.2-.42-.45-.28z" />;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[10] !== props || $[11] !== t1) {
    t5 = <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128" className={t1} {...props}>{t2}{t3}{t4}</svg>;
    $[10] = props;
    $[11] = t1;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}